'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dLogin$002dMode from "./presto.types$-Login-Mode.js";
var $p;
/** @constructor */
function $c_Lpresto_types$LoginMode$$anon$80(_$ordinal$29, \u03b4name$29, outer) {
  this.cz6 = 0;
  this.aac = null;
  this.cz6 = _$ordinal$29;
  this.aac = \u03b4name$29;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$LoginMode$$anon$80 as $c_Lpresto_types$LoginMode$$anon$80 };
$p = $c_Lpresto_types$LoginMode$$anon$80.prototype = new $j_presto$002etypes$0024$002dLogin$002dMode.$h_Lpresto_types$LoginMode();
$p.constructor = $c_Lpresto_types$LoginMode$$anon$80;
/** @constructor */
function $h_Lpresto_types$LoginMode$$anon$80() {
}
export { $h_Lpresto_types$LoginMode$$anon$80 as $h_Lpresto_types$LoginMode$$anon$80 };
$h_Lpresto_types$LoginMode$$anon$80.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.aac;
});
$p.l = (function() {
  return this.aac;
});
var $d_Lpresto_types$LoginMode$$anon$80 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$LoginMode$$anon$80, "presto.types$LoginMode$$anon$80", ({
  a0M: 1,
  a0K: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$LoginMode$$anon$80 as $d_Lpresto_types$LoginMode$$anon$80 };
//# sourceMappingURL=presto.types$-Login-Mode$$anon$80.js.map
